import {CheckboxOption} from 'components/Form/Checkboxes';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import {c} from 'ttag';

import {BackendData} from './types';

const approvalSettingsLabel = () => ({
    direct_approval_disabled: c('approval-settings')
        .t`Prevent all Direct Approvals of Documents`,
    editing_on_approval_request_disabled: c('approval-settings')
        .t`Disable Editing of Documents with Approval Requests`,
    is_editing_on_approval_disabled: c('approval-settings')
        .t`Disable Editing of Approved Documents`,
    self_approval_disabled: c('approval-settings')
        .t`Prevent Direct Approval by the Document's Creator`,
});
export const approvalSettingsCheckboxOptions = (): CheckboxOption[] => {
    const labels = approvalSettingsLabel();
    return [
        {
            label: labels.is_editing_on_approval_disabled,
            name: 'is_editing_on_approval_disabled',
        },
        {
            label: labels.editing_on_approval_request_disabled,
            name: 'editing_on_approval_request_disabled',
        },
        {
            label: (
                <span className="inline-flex items-center gap-2">
                    {labels.self_approval_disabled}
                    <TooltipIcon
                        message={c('approval-settings')
                            .t`Not applied when using Approval Flow`}
                        size="base"
                    />
                </span>
            ),
            name: 'self_approval_disabled',
        },
        {
            label: (
                <span className="inline-flex items-center gap-2">
                    {labels.direct_approval_disabled}
                    <TooltipIcon
                        message={c('approval-settings')
                            .t`Must use Approval Flow`}
                        size="base"
                    />
                </span>
            ),
            name: 'direct_approval_disabled',
        },
    ];
};

export const checker = () => {
    return {
        flowHasRevokedUser: (
            users: BackendData['data']['users'],
            flows: BackendData['data']['approvalFlows'],
        ): boolean => {
            return flows.some((flow) =>
                flow.steps.some((approver) => {
                    const user = users.find((u) => u.mid === approver.teamMid);
                    return user?.revoked ?? false;
                }),
            );
        },
    };
};
